<template>
  <v-container fluid>
    <PageTitle>
      <v-icon left>
        fas fa-fw fa-comments
      </v-icon>
      Edit Text Message Template
    </PageTitle>
    <v-form @submit.prevent="submit"
            :disabled="form.busy"
            autocomplete="off">
      <v-card class="mb-4">
        <SinchTemplateForm :form="form">
        </SinchTemplateForm>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Update
          </v-btn>
          <v-btn :to="{name: 'admin.sinch_templates.index'}"
                 :disabled="form.busy">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import {Form} from 'vform';
import SinchTemplateForm from './components/SinchTemplateForm.vue';
import sinchService from '../../services/sinchService';

export default {
  components: {SinchTemplateForm, PageTitle},
  data() {
    return {
      form: new Form({
        name: null,
        content: null,
        groups: [],
        status: 'Active',
        release_at: null,
        expires_at: null,
      }),
      template: null,
    }
  },
  computed: {},
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.template = await sinchService.getTemplate(this.$route.params.templateID);
      this.initForm(this.template);
    },
    initForm(template) {
      console.log('initForm', template);
      this.form.name = template.name;
      this.form.content = template.content;
      this.form.groups = template.groups.map(g => g.id);
      this.form.status = template.status;
      this.form.release_at = template.release_at;
      this.form.expires_at = template.expires_at;
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      const {data} = await this.form.patch(`/api/sinch/templates/${this.template.id}`);
      this.template = data;
      this.form.reset();
      this.initForm(data);
      this.$toast.success('Text message template updated.');
    }
  }
}
</script>
